const SearchBar = ({ handleSearch , text}) => {
    return (
        <div className="w-full h-[40px] flex flex-row items-center p-2 sm:p-4 bg-heroSearchbar rounded-full border-1 border-exploreSearchBorder">
            <button className="m-2">
                <svg width="20" height="20" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M26.9887 29.0104L37.5623 39.5828C38.119 40.1392 39.024 40.1392 39.5825 39.5828C40.1392 39.0244 40.1392 38.1194 39.5825 37.5626L29.0107 26.989C31.4106 24.134 32.8574 20.4491 32.8574 16.4287C32.8574 7.36201 25.4954 0 16.4287 0C7.36201 0 0 7.36201 0 16.4287C0 25.496 7.36201 32.8574 16.4287 32.8574C20.4489 32.8574 24.1337 31.4108 26.989 29.0107L26.9887 29.0104ZM16.4284 2.85618C23.9187 2.85618 30.0006 8.93816 30.0006 16.4284C30.0006 23.9187 23.9187 30.0007 16.4284 30.0007C8.93816 30.0007 2.85618 23.9187 2.85618 16.4284C2.85618 8.93816 8.93816 2.85618 16.4284 2.85618Z" fill="#9A0169" />
                </svg>
            </button>
            <input
                type="text"
                className="w-full h-5 p-2 text-[16px] focus:outline-none font-proximanova"
                placeholder={text}
                onChange={handleSearch}
            />
        </div>

    );
}

export default SearchBar;